export default function About() {
	return (
		<div className="h-screen flex justify-center items-center bg-yellow-300 ">
			<h1 className="md:text-9xl text-4xl font-black">アバウト・ページ</h1>
		</div>
	);
}
